var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmookingStickClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41417 7.99981L15.7782 14.3638L14.364 15.778L7.99997 9.41411L1.63601 15.778L0.221802 14.3638L6.58577 7.99981L0.221802 1.63589L1.63601 0.22168L7.99997 6.58561L14.364 0.22168L15.7782 1.63589L9.41417 7.99981Z",
    fill: "#DFDFDF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmookingStickClose);
export default __webpack_public_path__ + "static/media/smooking-stick-close.1a7981637238695914379bedc8229a4d.svg";
export { ForwardRef as ReactComponent };